export const environment = {
  production: true,
  baseUrl: '/app/',
  enableCaptcha: true,
  captchaKey: '6Lc_wz4gAAAAACQb5G1tBuZS3IhTKUeuC6lj_YBv',
  mapsKey: 'AIzaSyDccuSqSOHVf6pQvG_5Yd3DcWgF4HzvbOw',
};
